import Service from "../../components/Service/Service";

const Included = () => {
  return (
    <div className="container">
      <div className="column w64 g1">
        <h2>What's Included</h2>
        <div className="columns g1">
          <div className="column">
            <strong className="title">Payroll Processing</strong>
            <div className="column background_light shadow">
              <Service>
                <p>Bi-weekly and semi-monthly options</p>
              </Service>
              <Service>
                <p>Preparation and submission</p>
              </Service>
              <Service>
                <p>Summary and detail reports</p>
              </Service>
            </div>
          </div>
          <div className="column">
            <strong className="title">Payroll Maintenance</strong>
            <div className="column background_light shadow">
              <Service>
                <p>Time tracking for hourly employees</p>
              </Service>
              <Service>
                <p>New hire setup</p>
              </Service>
              <Service>
                <p>Terminated employee inactivation</p>
              </Service>
              <Service>
                <p>Custom reporting available</p>
              </Service>
            </div>
          </div>
        </div>
        <div className="column">
          <strong className="title">State and Federal Requirements</strong>
          <div className="columns background_light shadow">
            <div className="column">
              <Service>
                <p>Time tracking for hourly employees</p>
              </Service>
              <Service>
                <p>New hire setup</p>
              </Service>
            </div>
            <div className="column">
              <Service>
                <p>Terminated employee inactivation</p>
              </Service>
              <Service>
                <p>Custom reporting available</p>
              </Service>
            </div>
          </div>
        </div>
        <a
          className="cta"
          href="https://calendar.app.google/cgho9MaUp1oADCZLA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get started
        </a>
      </div>
    </div>
  );
};

export default Included;
